import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate, useLocation as useRouter } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import { useLocation } from "@/contexts/location-context";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetchCartItems,
  addOrUpdateCartItem,
  decreaseCartItem,
  removeCartItem,
  addOrUpdateGuestCartItem,
  decreaseGuestCartItem,
  removeGuestCartItem,
  createGuestOrder,
  fetchCities,
  fetchOrganizerDirectory,
} from "@/apiEndpoints";
import { fetchGuestCartItems } from "@/apiEndpoints";
import LogoBigColor from "@/icons/LogoBigColor";
import LogoBigWhite from "@/icons/LogoBigWhite";
import LogoBigBlack from "@/icons/LogoBigBlack";
import LogoColor from "@/icons/LogoColor";
import { IconArrowUpRight as ArrowUpRight, IconArrowsLeftRight as ArrowLeftRight, IconChevronDown as ChevronDown, IconTicket as Ticket, IconHeart as Heart, IconCalendar as Calendar, IconLogout as LogOut, IconSearch as SearchIcon, IconBuildingSkyscraper as Building2, IconBuilding as Building, IconMenu2 as Menu, IconX as X, IconArrowRight as ArrowRight, IconCalendarEvent, IconHeart, IconHelpSquare, IconLogin, IconLogout, IconShieldLock, IconSwitchHorizontal, IconTicket, IconUserCircle } from '@tabler/icons-react';
import DarkLightSwitch from "./DarkLightSwitch";
import Cart from "@/icons/Cart";
import Plus from "@/icons/Plus";
import Minus from "@/icons/Minus";
import Trash from "@/icons/Trash";
import Avatar from "./Avatar";
import ProfileMenuIcon from "@/icons/ProfileMenuIcon";
import HamburgerIcon from "@/icons/HamburgerIcon";
import PlusIcon from "./PlusIcon";
import OrganizationSelector, {
  type OrganizationSelectorMenuItem,
} from "./OrganizationSelector";
import { currencySymbol } from '@/utils/currency';
// removed cart-context import
/* 
function CartPopup({ open, onClose, cart }: { open: boolean; onClose: () => void; cart: any[] }) {
    const { setCart, user, guestCartId } = useAuth();
    const isGuest = !user;
    // Mutations for cart actions
    const refetchCart = async () => {
        // Optionally, you can refetch cart items from API, but here we assume parent keeps cart in sync
        if (isGuest && guestCartId) {
            const updatedCart = await fetchGuestCartItems(guestCartId);
            setCart(updatedCart || []);
        } else if (user?.userId) {
            const updatedCart = await fetchCartItems();
            setCart(updatedCart || []);
        }
    };
    const increaseMutation = useMutation({
        mutationFn: async (item: any) => {
            if (isGuest && guestCartId) {
                await addOrUpdateGuestCartItem({ eventId: item.eventId || item.event?._id || item.id, ticketId: item.ticketId || item.ticket?._id, selectedDate: item.selectedDate, quantity: item.quantity + 1, guestCartId });
            } else {
                await addOrUpdateCartItem({ eventId: item.eventId || item.event?._id || item.id, ticketId: item.ticketId || item.ticket?._id, selectedDate: item.selectedDate, quantity: item.quantity + 1 });
            }
        },
        onSuccess: refetchCart,
    });
    const decreaseMutation = useMutation({
        mutationFn: async (item: any) => {
            if (isGuest && guestCartId) {
                await decreaseGuestCartItem(guestCartId, item.eventId || item.event?._id || item.id, item.ticketId || item.ticket?._id, item.selectedDate);
            } else {
                await decreaseCartItem(item.eventId || item.event?._id || item.id, item.ticketId || item.ticket?._id, item.selectedDate);
            }
        },
        onSuccess: refetchCart,
    });
    const removeMutation = useMutation({
        mutationFn: async (item: any) => {
            if (isGuest && guestCartId) {
                await removeGuestCartItem(guestCartId, item.eventId || item.event?._id || item.id, item.ticketId || item.ticket?._id, item.selectedDate);
            } else {
                await removeCartItem(item.eventId || item.event?._id || item.id, item.ticketId || item.ticket?._id, item.selectedDate);
            }
        },
        onSuccess: refetchCart,
    });
    const total = cart.reduce((sum, item) => sum + (Number(item?.ticket?.price || 0) * item.quantity), 0);
    if (!open) return null;
    const renderCartItem = (item: any, compact: boolean) => (
        <div key={item.id} className="flex items-center gap-3 border-b last:border-b-0 pb-3 last:pb-0">
            <img src={item?.event?.attachments?.banner?.link} alt={item?.event?.title} width={48} height={48} className="rounded object-cover w-12 h-12" />
            <div className="flex-1 min-w-0">
                <div className={`font-vazirmatn font-medium text-gray-800 truncate ${compact ? 'max-w-[150px]' : 'max-w-[160px]'}`}>{item?.event?.title}</div>
                
                {item?.ticket?.name && (
                    <div className="text-xs text-gray-600 font-medium mt-1 truncate">
                        {item.ticket.name}
                    </div>
                )}
                <div className={`flex items-center gap-2 mt-2 ${compact ? 'justify-between' : ''}`}>                    <div className="flex items-center gap-2">
                    <button
                        className="w-7 h-7 rounded border-gray-300 flex items-center justify-center text-lg font-bold text-primary40 bg-primary40 disabled:opacity-50"
                        onClick={() => decreaseMutation.mutate(item)}
                        disabled={item.quantity <= 1 || decreaseMutation.isPending}
                    >
                        <Minus />
                    </button>
                    <span className="text-center font-semibold text-base">{item.quantity}</span>
                    <button
                        className="w-7 h-7 rounded border-gray-300 flex items-center justify-center text-lg font-bold text-primary40 bg-primary40 disabled:opacity-50"
                        onClick={() => increaseMutation.mutate(item)}
                        disabled={increaseMutation.isPending}
                    >
                        <Plus />
                    </button>
                    <button
                        className="ml-2 text-gray-400 hover:text-red-500 disabled:opacity-50"
                        title="Remove"
                        onClick={() => removeMutation.mutate(item)}
                        disabled={removeMutation.isPending}
                    >
                        <Trash />
                    </button>
                </div>
                    <div className="font-bold text-primary40 text-lg ml-2">{currencySymbol(item?.event?.currency)}{Number(item?.ticket?.price || 0).toFixed(2)}</div>
                </div>
            </div>
        </div>
    );
    return (
        <>
            
            <div data-cart-popup className="fixed top-[52px] left-1/2 -translate-x-1/2 z-50 w-[95vw] max-w-xs bg-white rounded shadow-2xl border border-gray-100 p-4 md:hidden">
                <div className="font-semibold text-gray-500 text-base mb-4">{cart.length} Items</div>
                <div className="flex flex-col gap-4 max-h-72 overflow-y-auto">
                    {cart.length === 0 ? (
                        <div className="text-center text-gray-400 py-8">Your cart is empty.</div>
                    ) : cart.map(item => renderCartItem(item, true))}
                </div>
                <div className="flex justify-between items-center mt-6 mb-4 text-lg font-semibold text-gray-700">
                    <span>Total:</span>
                    <span>{currencySymbol(cart[0]?.event?.currency)}{total.toFixed(2)}</span>
                </div>
                <a href="/checkout" className="w-full bg-primary40 text-white py-3 rounded font-bold text-lg hover:bg-primary50 transition block text-center">Checkout</a>
            </div>
            
            <div data-cart-popup className="absolute right-0 top-[52px] w-96 bg-white rounded shadow-2xl border border-gray-100 z-50 p-4 hidden md:block" style={{ minWidth: 340 }}>
                <div className="font-semibold text-gray-500 text-base mb-4">{cart.length} Items</div>
                <div className="flex flex-col gap-4 max-h-72 overflow-y-auto">
                    {cart.length === 0 ? (
                        <div className="text-center text-gray-400 py-8">Your cart is empty.</div>
                    ) : cart.map(item => renderCartItem(item, true))}
                </div>
                <div className="flex justify-between items-center mt-6 mb-4 text-lg font-semibold text-gray-700">
                    <span>Total:</span>
                    <span>{currencySymbol(cart[0]?.event?.currency)}{total.toFixed(2)}</span>
                </div>
                <a href="/checkout" className="w-full bg-primary40 text-white py-3 rounded font-bold text-lg hover:bg-primary50 transition block text-center">Checkout</a>
            </div>
        </>
    );
} */

interface HeaderProps {
  onMenuClick?: () => void;
  children?: React.ReactNode;
  onLocationChange?: (location: any) => void;
  // When provided, the header switches into "organizer" mode: the Help/Create Event
  // links are replaced with these nav items, and the profile avatar is replaced with
  // the organization selector (email + org list + these same items in its dropdown).
  organizerNav?: {
    items: OrganizationSelectorMenuItem[];
    email?: string;
    // Hides the mobile top bar (keeps the mobile bottom nav) — for pages that render
    // their own mobile-only top bar, e.g. Create Event's Back/Save Event bar.
    hideMobileTopBar?: boolean;
  };
  // Mobile-only: the compact logo + search + menu bar. This is the default mobile
  // header everywhere; pass false to opt back into the old Explore/create/avatar bar.
  // Organizer pages (organizerNav) always keep their own dedicated mobile bar regardless.
  compactMobileHeader?: boolean;
  // Compact mobile header only: hide the hamburger/avatar icons (e.g. pages that
  // already surface the user prominently elsewhere, like the profile page).
  compactHideIcons?: boolean;
  // Compact mobile header only: invert the usual light/dark background so it reads
  // dark (nightBg) in light mode and the page's light grey (#E8E8E8) in dark mode —
  // used on pages whose body background is intentionally theme-invariant.
  compactSwapTheme?: boolean;
}

const Header = ({
  onMenuClick,
  children,
  onLocationChange,
  organizerNav,
  compactMobileHeader = true,
  compactHideIcons = false,
  compactSwapTheme = false,
}: HeaderProps) => {
  const navigate = useNavigate();
  const router = useRouter();
  const isOrganizationPage = router.pathname.startsWith("/organizations");
  const [userOpen, setUserOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [cartOpen, setCartOpen] = useState(false);
  const [cityMenuOpen, setCityMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const {
    selectedLocation,
    setSelectedLocation,
    availableCities,
    setAvailableCities,
  } = useLocation();
  const {
    user,
    isAuthenticated,
    isLoading,
    logout,
    cart,
    setCart,
    guestCartId,
  } = useAuth();
  const [mounted, setMounted] = useState(false);
  const onLocationChangeRef = React.useRef(onLocationChange);
  onLocationChangeRef.current = onLocationChange;

  useEffect(() => {
    if (userOpen) setCityMenuOpen(false);
  }, [userOpen]);

  useEffect(() => {
    if (cityMenuOpen) setUserOpen(false);
  }, [cityMenuOpen]);
  const isOrganizer = !!user?.organizer;
  const isSiteAdmin = Boolean(user?.permissions?.includes("ADMIN"));

  // Shown in the organization selector's dropdown, below the org list (organizer mode).
  const switchToAttendingMenuItem: OrganizationSelectorMenuItem = {
    key: "switch-attending",
    label: "Switch to Attending",
    icon: <IconSwitchHorizontal size={24} stroke={1.5} color="#354052" />
    ,
    onClick: () => navigate("/"),
  };
  const profileMenuItems: OrganizationSelectorMenuItem[] = [
    {
      key: "help",
      label: "Help",
      icon: <IconHelpSquare size={24} stroke={1.5} color="#354052" />
      ,
      onClick: () => navigate("/help"),
    },
    ...(isSiteAdmin ? [{
      key: "admin",
      label: "Admin panel",
      icon: <IconShieldLock size={24} stroke={1.5} color="#354052" />,
      onClick: () => navigate("/admin"),
    }] : []),
    {
      key: "logout",
      label: "Logout",
      divider: true,
      icon: <IconLogout size={24} stroke={1.5} color="#354052" />
      ,
      onClick: () => logout(),
    },
  ];

  // Shared user dropdown (attendee mode): Tickets/Likes/Help/Account Settings/Logout,
  // plus the organizer entry point — "I'm an Organizer" for attendees, or "Switch to
  // Organizing" (placed first) for users who already have an organization.
  const attendeeCoreMenuItems: OrganizationSelectorMenuItem[] = [
    {
      key: "tickets", label: "My Tickets", icon: <IconTicket size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/profile/tickets")
    },
    {
      key: "likes", label: "Likes", icon: <IconHeart size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/profile/likes")
    },
    {
      key: "help", label: "Help", icon: <IconHelpSquare size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/help")
    },
    ...(isSiteAdmin ? [{
      key: "admin", label: "Admin panel", icon: <IconShieldLock size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/admin")
    }] : []),
    {
      key: "account", label: "Account Settings", divider: true, icon: <IconUserCircle size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/profile")
    },
    {
      key: "logout", label: "Logout", icon: <IconLogout size={24} stroke={1.5} color="#354052" />
      , onClick: () => logout()
    },
  ];
  const organizerSwitchItem: OrganizationSelectorMenuItem = isOrganizer
    ? {
      key: "switch-organizing", label: "Switch to Organizing", icon: <IconSwitchHorizontal size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/organizations")
    }
    : {
      key: "become-organizer", label: "I'm an Organizer", divider: true, icon: <IconCalendarEvent size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/organizations")
    };
  const attendeeMenuItems: OrganizationSelectorMenuItem[] = isOrganizer
    ? [organizerSwitchItem, { ...attendeeCoreMenuItems[0], divider: true }, ...attendeeCoreMenuItems.slice(1)]
    : [...attendeeCoreMenuItems, organizerSwitchItem];
  // Compact mobile header (Home) keeps the avatar menu minimal: organizer entry point, account settings and logout.
  const compactMobileMenuItems: OrganizationSelectorMenuItem[] = [
    { ...organizerSwitchItem, divider: false },
    { ...attendeeCoreMenuItems.find((item) => item.key === "account")!, divider: true },
    { ...attendeeCoreMenuItems[attendeeCoreMenuItems.length - 1], divider: false },
  ];
  // Compact mobile header, signed-out state: hamburger menu with Login and Help.
  const guestMobileMenuItems: OrganizationSelectorMenuItem[] = [
    {
      key: "login", label: "Login / Sign up", icon: <IconLogin size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/login")
    },
    {
      key: "help", label: "Help", icon: <IconHelpSquare size={24} stroke={1.5} color="#354052" />
      , onClick: () => navigate("/help")
    },
  ];
  // removed cart-context import

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        setSearchOpen(true);
      }
      if (event.key === "Escape") {
        setSearchOpen(false);
        setMenuOpen(false);
        setUserOpen(false);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  useEffect(() => {
    if (!searchOpen && !menuOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [searchOpen, menuOpen]);

  useEffect(() => {
    if (!userOpen) return;
    const onMouseDown = (event: MouseEvent) => {
      if (!(event.target as Element).closest(".user-menu-root")) setUserOpen(false);
    };
    document.addEventListener("mousedown", onMouseDown);
    return () => document.removeEventListener("mousedown", onMouseDown);
  }, [userOpen]);

  // Fetch available cities using useQuery
  const { data: citiesData, isLoading: citiesLoading } = useQuery({
    queryKey: ["cities"],
    queryFn: async () => {
      const citiesData = await fetchCities();
      console.log("Cities data from API:", citiesData);

      const citiesWithCoords = citiesData.map((city: any) => ({
        lat: city.latitude || 0,
        lng: city.longitude || 0,
        city: city.name || city.city,
        address: city.state ? `${city.name}, ${city.state}` : city.name,
        hasCoordinates: !!(city.latitude && city.longitude),
      }));

      console.log("Transformed cities:", citiesWithCoords);
      return citiesWithCoords;
    },
    staleTime: 15 * 60 * 1000, // 15 minutes
  });

  // Organizer count for the Explore menu
  const { data: organizerDirectory } = useQuery({
    queryKey: ["organizerDirectory"],
    queryFn: fetchOrganizerDirectory,
    enabled: cityMenuOpen,
    staleTime: 15 * 60 * 1000,
  });

  // Update availableCities when citiesData changes
  useEffect(() => {
    if (citiesData) {
      setAvailableCities(citiesData);
    }
  }, [citiesData, setAvailableCities]);

  // Initial location restoration - runs once on mount
  useEffect(() => {
    if (mounted && typeof window !== "undefined") {
      // Priority 1: URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const locationParam = urlParams.get("location");

      if (locationParam) {
        // Store URL parameter for when cities are loaded
        setSelectedLocation({ city: locationParam, address: locationParam });
        onLocationChangeRef.current?.({ city: locationParam, address: locationParam });
        return;
      }

      // Priority 2: localStorage
      try {
        const savedLocation = localStorage.getItem("selectedLocation");
        if (savedLocation) {
          const parsedLocation = JSON.parse(savedLocation);
          if (
            parsedLocation.city === "My Location" ||
            parsedLocation.city === "my-location"
          ) {
            const myLocation = { city: "My Location", address: "My Location" };
            setSelectedLocation(myLocation);
            onLocationChangeRef.current?.(myLocation);
          } else {
            // Set saved location immediately, even if cities aren't loaded yet
            setSelectedLocation(parsedLocation);
            onLocationChangeRef.current?.(parsedLocation);
          }
        }
      } catch (error) {
        console.error("Error loading saved location:", error);
      }
    }
  }, [mounted]);

  // Sync with available cities when they load
  useEffect(() => {
    if (mounted && availableCities.length > 0 && selectedLocation) {
      // If we have a selected location and cities are now loaded, try to match it
      if (selectedLocation.city !== "My Location") {
        const matchedCity = availableCities.find(
          (c) => c.city === selectedLocation.city,
        );
        if (matchedCity) {
          // Update with the full city data from API
          setSelectedLocation(matchedCity);
          onLocationChangeRef.current?.(matchedCity);
        }
      }
    }
  }, [mounted, availableCities, selectedLocation]);

  // Close cart popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (
        cartOpen &&
        !target.closest("[data-cart-popup]") &&
        !target.closest("[data-cart-button]")
      ) {
        setCartOpen(false);
      }
    };

    if (cartOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cartOpen]);

  // Close the Explore/city dropdown when clicking outside or pressing Escape
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (cityMenuOpen && !target.closest(".explore-city-menu")) {
        setCityMenuOpen(false);
      }
    };
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setCityMenuOpen(false);
    };

    if (cityMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [cityMenuOpen]);

  const userId = user?.userId;
  const isGuest = !userId;
  const getCachedCart = () => {
    if (typeof window === "undefined" || !mounted) return [];
    try {
      const cached = localStorage.getItem("cart");
      return cached ? JSON.parse(cached) : [];
    } catch {
      return [];
    }
  };
  const { data: cartData = [], isLoading: cartLoading } = useQuery({
    queryKey: isGuest ? ["guestCartItems", guestCartId] : ["cartItems", userId],
    queryFn: () => {
      if (isGuest && guestCartId) {
        return fetchGuestCartItems(guestCartId);
      } else if (userId) {
        return fetchCartItems();
      }
      return Promise.resolve([]);
    },
    enabled: false,
    initialData: getCachedCart(),
    refetchOnMount: "always",
    staleTime: 0,
  });
  // Cache cart in localStorage when cartData changes
  useEffect(() => {
    if (mounted && typeof window !== "undefined" && Array.isArray(cartData)) {
      localStorage.setItem("cart", JSON.stringify(cartData));
      setCart(cartData);
    }
  }, [cartData, mounted]);
  useEffect(() => {
    //if (typeof setCart === 'function' && Array.isArray(cartData)) {
    //if (JSON.stringify(cart) !== JSON.stringify(cartD ta)) {
    //setCart(cartData);
    //}
    //}
  }, [cartData, setCart, cart]);

  if (!mounted) return null;

  function routeCondition() {
    const pathname = window.location.pathname;

    // Exclude /event/:id (but include /events)
    if (pathname.startsWith("/event/") && !pathname.startsWith("/events")) {
      return false;
    }

    // Exclude /e/:handle
    if (pathname.startsWith("/e/")) {
      return false;
    }

    // Exclude /checkout
    if (pathname.includes("/checkout")) {
      return false;
    }

    return true;
  }

  // Search and city selector should also show on event detail pages
  function searchAndLocationCondition() {
    const pathname = window.location.pathname;

    // Exclude /checkout
    if (pathname.includes("/checkout")) {
      return false;
    }

    // Organizer mode replaces search/location with the organizer nav
    if (organizerNav) {
      return false;
    }

    return true;
  }

  const menuShell =
    "absolute z-50 overflow-hidden rounded-2xl bg-white p-1.5 shadow-[0_24px_60px_-12px_rgba(7,26,27,0.28)] ring-1 ring-black/5 dark:bg-nightSurface dark:ring-white/10 dark:shadow-[0_24px_60px_-12px_rgba(0,0,0,0.9)] animate-fade-in";

  function renderExploreMenu(align: "left" | "right" = "left") {
    const items = [
      {
        key: "cities",
        label: "Cities",
        description: "Browse events by city",
        Icon: Building2,
        onClick: () => {
          setCityMenuOpen(false);
          navigate("/search?browse=cities");
        },
      },
      {
        key: "organizers",
        label: "Organizations",
        description: organizerDirectory?.length ? `${organizerDirectory.length} hosts to follow` : "Discover hosts to follow",
        Icon: Building,
        onClick: () => {
          setCityMenuOpen(false);
          navigate("/search?browse=organizers");
        },
      },
    ];
    return (
      <div className={`${menuShell} ${align === "right" ? "right-0" : "left-0"} top-full mt-2 w-64`}>
        {items.map(({ key, label, description, Icon, onClick }) => (
          <button
            key={key}
            type="button"
            onClick={onClick}
            className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors hover:bg-grey99 dark:hover:bg-nightElevated"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary99 text-primary30 dark:bg-nightElevated dark:text-nightAccent">
              <Icon className="h-[18px] w-[18px]" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-grey10 dark:text-white">{label}</span>
              <span className="block truncate text-xs text-grey40 dark:text-nightMuted">{description}</span>
            </span>
          </button>
        ))}
      </div>
    );
  }

  function renderUserMenu(items: OrganizationSelectorMenuItem[], position: string) {
    const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
    const email = (user as any)?.email;
    return (
      <div className={`${menuShell} ${position} w-64`}>
        {isAuthenticated && user && (
          <div className="mb-1.5 flex items-center gap-3 border-b border-grey95 px-3 pb-3 pt-2 dark:border-nightBorder">
            <Avatar src={user?.profileImage} name={fullName} seed={user?.userId} size={36} />
            <div className="min-w-0">
              <div className="truncate text-sm font-semibold capitalize text-grey10 dark:text-white">{fullName || "My account"}</div>
              {email && <div className="truncate text-xs text-grey40 dark:text-nightMuted">{email}</div>}
            </div>
          </div>
        )}
        {items.map((item) => (
          <div key={item.key}>
            {item.divider && <div className="mx-2 my-1.5 h-px bg-grey95 dark:bg-nightBorder" />}
            <button
              type="button"
              onClick={() => {
                setUserOpen(false);
                item.onClick();
              }}
              className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium transition-colors hover:bg-grey99 dark:hover:bg-nightElevated ${item.key === "logout" ? "text-error40 dark:text-error60" : "text-grey10 dark:text-nightTextSecondary"}`}
            >
              <span className="flex h-5 w-5 shrink-0 items-center justify-center [&_path]:stroke-current [&_svg]:h-5 [&_svg]:w-5">
                {item.icon}
              </span>
              {item.label}
            </button>
          </div>
        ))}
      </div>
    );
  }

  const submitSearch = (term: string) => {
    const searchParams = new URLSearchParams();
    if (term.trim()) searchParams.set("q", term.trim());
    if (selectedLocation?.city && selectedLocation.city !== "my-location" && selectedLocation.city !== "My Location") {
      searchParams.set("location", selectedLocation.city);
    }
    setSearchOpen(false);
    setMenuOpen(false);
    const query = searchParams.toString();
    navigate(query ? `/search?${query}` : "/search");
  };

  const navLinks = [
    { label: "Events", href: "/search", active: router.pathname === "/search" && !router.search.includes("browse=") },
    { label: "Cities", href: "/search?browse=cities", active: router.search.includes("browse=cities") },
    { label: "Organizers", href: "/search?browse=organizers", active: router.search.includes("browse=organizers") },
    { label: "Help", href: "/help", active: router.pathname === "/help" },
  ];

  const popularSearches = ["Live music", "Comedy", "Yoga", "Networking", "Festival", "Workshop"];

  const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();

  const logo = (
    <a href="/" aria-label="Home" className="flex shrink-0 items-center">
      <LogoBigColor height={26} width={112} className="dark:hidden" />
      <LogoBigWhite height={26} width={112} className="hidden dark:block" />
    </a>
  );

  const pillClass =
    "pointer-events-auto mx-auto flex items-center rounded-full bg-white/95 ring-1 ring-black/[0.06] shadow-[0_10px_40px_-16px_rgba(0,0,0,0.25)] dark:bg-[#121212]/95 dark:ring-white/10 dark:shadow-[0_10px_40px_-16px_rgba(0,0,0,0.9)]";

  function renderSearchOverlay() {
    if (!searchOpen) return null;
    return (
      <div className="fixed inset-0 z-[10002] flex items-start justify-center bg-black/40 px-4 pt-[12vh] animate-fade-in" onMouseDown={() => setSearchOpen(false)}>
        <div
          className="w-full max-w-2xl overflow-hidden rounded-[28px] bg-white shadow-[0_40px_120px_-20px_rgba(0,0,0,0.5)] ring-1 ring-black/5 dark:bg-[#141414] dark:ring-white/10"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch(search);
            }}
            className="flex items-center gap-3 border-b border-grey95 px-6 dark:border-white/10"
          >
            <SearchIcon className="h-6 w-6 shrink-0 text-primary dark:text-nightAccent" />
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search events, organizers, cities"
              aria-label="Search"
              className="h-20 min-w-0 flex-1 bg-transparent text-xl font-medium tracking-[-0.01em] text-grey10 placeholder:text-grey60 dark:text-white dark:placeholder:text-nightMuted"
            />
            <button type="button" onClick={() => setSearchOpen(false)} className="rounded-lg px-2 py-1 text-xs font-semibold text-grey40 ring-1 ring-grey90 dark:text-nightMuted dark:ring-white/15">
              ESC
            </button>
          </form>
          <div className="p-6">
            <div className="text-xs font-bold uppercase tracking-[0.16em] text-grey50 dark:text-nightMuted">Popular</div>
            <div className="mt-3 flex flex-wrap gap-2">
              {popularSearches.map((term) => (
                <button
                  key={term}
                  type="button"
                  onClick={() => submitSearch(term)}
                  className="h-9 rounded-full bg-grey99 px-4 text-sm font-medium text-grey20 transition-colors hover:bg-grey10 hover:text-white dark:bg-white/[0.06] dark:text-nightTextSecondary dark:hover:bg-white dark:hover:text-nightBg"
                >
                  {term}
                </button>
              ))}
            </div>
            <div className="mt-6 grid gap-2 sm:grid-cols-3">
              {[
                { label: "All events", href: "/search", Icon: SearchIcon },
                { label: "Cities", href: "/search?browse=cities", Icon: Building2 },
                { label: "Organizers", href: "/search?browse=organizers", Icon: Building },
              ].map(({ label, href, Icon }) => (
                <button
                  key={href}
                  type="button"
                  onClick={() => {
                    setSearchOpen(false);
                    navigate(href);
                  }}
                  className="group flex items-center gap-3 rounded-2xl p-3 text-left transition-colors hover:bg-grey99 dark:hover:bg-white/[0.06]"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary99 text-primary30 dark:bg-white/[0.06] dark:text-nightAccent">
                    <Icon className="h-[18px] w-[18px]" />
                  </span>
                  <span className="text-sm font-semibold text-grey10 dark:text-white">{label}</span>
                  <ArrowRight className="ml-auto h-4 w-4 text-grey60 opacity-0 transition-opacity group-hover:opacity-100" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderMobileMenu() {
    if (!menuOpen) return null;
    const go = (href: string) => {
      setMenuOpen(false);
      navigate(href);
    };
    return (
      <div className="fixed inset-0 z-[10001] flex flex-col bg-white dark:bg-nightBg md:hidden animate-fade-in">
        <div className="flex h-[72px] shrink-0 items-center justify-between px-5">
          {logo}
          <button type="button" aria-label="Close menu" onClick={() => setMenuOpen(false)} className="flex h-11 w-11 items-center justify-center rounded-full bg-grey99 text-grey10 dark:bg-white/[0.08] dark:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 pb-10">
          {isAuthenticated && user && (
            <div className="mt-2 flex items-center gap-3 rounded-3xl bg-grey99 p-4 dark:bg-white/[0.06]">
              <Avatar src={user?.profileImage} name={fullName} seed={user?.userId} size={44} />
              <div className="min-w-0">
                <div className="truncate text-base font-bold capitalize text-grey10 dark:text-white">{fullName || "My account"}</div>
                <button type="button" onClick={() => go("/profile")} className="text-sm font-medium text-primary dark:text-nightAccent">
                  View profile
                </button>
              </div>
            </div>
          )}
          <nav className="mt-6 flex flex-col">
            {navLinks.map((link) => (
              <button
                key={link.href}
                type="button"
                onClick={() => go(link.href)}
                className={`flex items-center justify-between border-b border-grey95 py-4 text-left text-[34px] font-bold tracking-[-0.04em] dark:border-white/[0.08] ${link.active ? "text-primary dark:text-nightAccent" : "text-grey10 dark:text-white"}`}
              >
                {link.label}
                <ArrowRight className="h-6 w-6 -rotate-45 opacity-40" />
              </button>
            ))}
          </nav>
          {isAuthenticated ? (
            <div className="mt-6 flex flex-col">
              {attendeeMenuItems.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => {
                    setMenuOpen(false);
                    item.onClick();
                  }}
                  className={`flex items-center gap-3 rounded-2xl px-2 py-3 text-left text-base font-semibold ${item.key === "logout" ? "text-error40 dark:text-error60" : "text-grey20 dark:text-nightTextSecondary"}`}
                >
                  <span className="flex h-5 w-5 items-center justify-center [&_path]:stroke-current [&_svg]:h-5 [&_svg]:w-5">{item.icon}</span>
                  {item.label}
                </button>
              ))}
            </div>
          ) : (
            <div className="mt-8 grid grid-cols-2 gap-3">
              <button type="button" onClick={() => go("/login")} className="h-14 rounded-full text-base font-semibold text-grey10 ring-1 ring-grey90 dark:text-white dark:ring-white/15">
                Login
              </button>
              <button type="button" onClick={() => go("/signup")} className="h-14 rounded-full bg-grey10 text-base font-semibold text-white dark:bg-white dark:text-nightBg">
                Sign up
              </button>
              <button type="button" onClick={() => go("/organizations")} className="col-span-2 h-14 rounded-full bg-nightAccent text-base font-semibold text-nightBg">
                Host an event
              </button>
            </div>
          )}
          <div className="mt-10 flex items-center justify-between rounded-3xl bg-grey99 px-5 py-4 dark:bg-white/[0.06]">
            <span className="text-sm font-semibold text-grey20 dark:text-nightTextSecondary">Appearance</span>
            <DarkLightSwitch />
          </div>
        </div>
      </div>
    );
  }

  function renderAttendeeHeader() {
    return (
      <>
        {(
          <div className="pointer-events-none sticky top-0 z-[9999] px-3 pt-3 md:hidden">
            <div className={`${pillClass} h-14 max-w-[1200px] gap-1 pl-5 pr-1.5`}>
              {logo}
              <div className="flex-1" />
              <button type="button" aria-label="Search" onClick={() => setSearchOpen(true)} className="flex h-11 w-11 items-center justify-center rounded-full text-grey10 hover:bg-black/5 dark:text-white dark:hover:bg-white/10">
                <SearchIcon className="h-5 w-5" />
              </button>
              {onMenuClick && (
                <button type="button" aria-label="Open sidebar" onClick={onMenuClick} className="flex h-11 w-11 items-center justify-center rounded-full hover:bg-black/5 dark:hover:bg-white/10">
                  <ProfileMenuIcon />
                </button>
              )}
              {!compactHideIcons && (
                isAuthenticated ? (
                  <button data-testid="profile-mobile" type="button" aria-label="Open menu" onClick={() => setMenuOpen(true)} className="rounded-full p-0.5 ring-2 ring-nightAccent/70">
                    <Avatar src={user?.profileImage} name={fullName} seed={user?.userId} size={38} />
                  </button>
                ) : (
                  <button type="button" aria-label="Open menu" onClick={() => setMenuOpen(true)} className="flex h-11 w-11 items-center justify-center rounded-full bg-grey10 text-white dark:bg-white dark:text-nightBg">
                    <Menu className="h-5 w-5" />
                  </button>
                )
              )}
            </div>
          </div>
        )}

        <div className="pointer-events-none sticky top-0 z-[9999] hidden px-4 pt-4 md:block">
          <div className={`${pillClass} h-16 max-w-[1200px] gap-2 pl-7 pr-2`}>
            {logo}
            <nav className="ml-6 hidden items-center gap-1 lg:flex">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className={`relative flex h-10 items-center whitespace-nowrap rounded-full px-4 text-[15px] font-semibold transition-colors ${link.active ? "text-grey10 dark:text-white" : "text-grey40 hover:text-grey10 dark:text-nightMuted dark:hover:text-white"}`}
                >
                  {link.label}
                  {link.active && <span className="absolute bottom-1.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-primary dark:bg-nightAccent" />}
                </a>
              ))}
            </nav>
            <div className="flex-1" />
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="flex h-11 w-[200px] shrink-0 items-center gap-2.5 rounded-full bg-black/[0.04] pl-4 pr-2 text-left text-sm text-grey50 transition-colors hover:bg-black/[0.07] dark:bg-white/[0.06] dark:text-nightMuted dark:hover:bg-white/10 xl:w-[240px]"
            >
              <SearchIcon className="h-[18px] w-[18px]" />
              <span className="flex-1 truncate">Search events</span>
              <kbd className="rounded-md bg-white px-1.5 py-0.5 font-sans text-[11px] font-semibold text-grey40 ring-1 ring-black/[0.06] dark:bg-white/10 dark:text-nightMuted dark:ring-white/10">⌘K</kbd>
            </button>
            <a
              href="/organizations"
              className="hidden h-11 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-4 text-[15px] font-semibold text-grey10 transition-colors hover:bg-black/[0.04] dark:text-white dark:hover:bg-white/[0.06] xl:flex"
            >
              {isAuthenticated && isOrganizer ? (
                <>
                  <ArrowLeftRight className="h-4 w-4" /> Organizer mode
                </>
              ) : (
                <>
                  Host an event <ArrowUpRight className="h-4 w-4" />
                </>
              )}
            </a>
            {isAuthenticated ? (
              <div className="user-menu-root relative">
                <button
                  data-testid="profile"
                  type="button"
                  onClick={() => setUserOpen((v) => !v)}
                  className={`flex items-center gap-1.5 rounded-full p-1 pr-3 transition-colors ${userOpen ? "bg-black/[0.06] dark:bg-white/10" : "hover:bg-black/[0.04] dark:hover:bg-white/[0.06]"}`}
                >
                  <Avatar src={user?.profileImage} name={fullName} seed={user?.userId} size={40} />
                  <ChevronDown className={`h-4 w-4 text-grey40 transition-transform dark:text-nightMuted ${userOpen ? "rotate-180" : ""}`} />
                </button>
                {userOpen && renderUserMenu(attendeeMenuItems, "right-0 top-[60px]")}
              </div>
            ) : (
              <>
                <a href="/login" className="flex h-11 shrink-0 items-center whitespace-nowrap rounded-full px-4 text-[15px] font-semibold text-grey10 transition-colors hover:bg-black/[0.04] dark:text-white dark:hover:bg-white/[0.06]">
                  Login
                </a>
                <a href="/signup" className="flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-grey10 pl-5 pr-2 text-[15px] font-semibold text-white transition-colors hover:bg-black dark:bg-white dark:text-nightBg dark:hover:bg-grey90">
                  Sign up
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-nightAccent text-nightBg">
                    <ArrowRight className="h-4 w-4" />
                  </span>
                </a>
              </>
            )}
          </div>
        </div>

        {renderSearchOverlay()}
        {renderMobileMenu()}
        {children}
      </>
    );
  }

  if (!organizerNav) return renderAttendeeHeader();

  return (
    <>
      {/* Mobile Header (fixed, with city selector dropdown) */}
      {!organizerNav?.hideMobileTopBar && (
      <header
        className={`md:hidden ${organizerNav ? "fixed top-0 left-0 right-0 h-16" : "sticky top-0"} z-[9999] ${compactSwapTheme ? "bg-nightBg dark:bg-[#E8E8E8]" : organizerNav ? "bg-white dark:bg-nightBg border-b border-black/[0.06] dark:border-white/[0.06]" : "bg-white dark:bg-nightBg border-b border-black/[0.06] dark:border-white/[0.06]"} w-full transition-colors`}
      >
        <div
          className={`flex items-center justify-between px-0 sm:px-4 ${compactSwapTheme ? "bg-nightBg dark:bg-[#E8E8E8]" : organizerNav ? "bg-transparent" : "bg-transparent"} rounded-t transition-colors ${organizerNav ? "h-16 pr-2" : "py-2.5"}`}
        >
          {compactMobileHeader && !organizerNav ? (
            <>
              {/* Logo + wordmark */}
              <a href="/" className="flex items-center gap-2 p-2 ml-2 min-w-0 flex-shrink-0">
                {compactSwapTheme ? (
                  <>
                    <LogoBigWhite height={24} width={100} className="dark:hidden" />
                    <LogoBigBlack height={24} width={100} className="hidden dark:block" />
                  </>
                ) : (
                  <>
                    <LogoBigColor height={24} width={100} className="dark:hidden" />
                    <LogoBigWhite height={24} width={100} className="hidden dark:block" />
                  </>
                )}
              </a>
              <div className="flex-1" />
              {/* Explore */}
              <div className="explore-city-menu flex items-center gap-1 relative">
                <button
                  type="button"
                  onClick={() => setCityMenuOpen((v) => !v)}
                  className={`flex h-9 items-center gap-1 rounded-full px-3 text-sm font-medium transition-colors ${compactSwapTheme ? "text-white dark:text-grey20" : "text-grey20 hover:bg-grey99 dark:text-nightTextSecondary dark:hover:bg-nightElevated"} ${cityMenuOpen && !compactSwapTheme ? "bg-grey99 dark:bg-nightElevated" : ""}`}
                  aria-label="Explore"
                >
                  Explore
                  <ChevronDown
                    className={`w-4 h-4 transition-transform ${cityMenuOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {cityMenuOpen && renderExploreMenu("right")}
              </div>

              {/* Icons */}
              {!compactHideIcons && (
              <div className="flex items-center gap-1 mr-2">
                {onMenuClick && (
                  <button
                    className="p-2 rounded hover:bg-gray-100 dark:hover:bg-white/10"
                    onClick={onMenuClick}
                    aria-label="Open menu"
                  >
                    <ProfileMenuIcon />
                  </button>
                )}

                {mounted &&
                  (isAuthenticated ? (
                    <button
                      data-testid="profile-mobile"
                      className="ml-1 rounded-full p-0.5 ring-1 ring-black/10 transition hover:ring-primary dark:ring-white/15"
                      onClick={() => setUserOpen((v) => !v)}
                    >
                      <Avatar
                        src={user?.profileImage}
                        name={`${user?.firstName || ""} ${user?.lastName || ""}`.trim()}
                        seed={user?.userId}
                        size={32}
                      />
                    </button>
                  ) : (
                    <button
                      className={`p-2 rounded hover:bg-gray-100 dark:hover:bg-white/10 ${compactSwapTheme ? "text-white dark:text-grey20" : "text-grey20 dark:text-nightTextSecondary"}`}
                      onClick={() => setUserOpen((v) => !v)}
                      aria-label="Open menu"
                    >
                      <HamburgerIcon />
                    </button>
                  ))}
                {userOpen && renderUserMenu(isAuthenticated ? compactMobileMenuItems : guestMobileMenuItems, "right-4 top-[56px]")}
              </div>
              )}
            </>
          ) : (
            <>
              {/* Logo */}
              <div className="flex items-center gap-2 p-2 ml-2 min-w-0">
                {!organizerNav && <a href="/" className="flex-shrink-0">
                  <LogoColor height={32} width={32} />
                </a>}
                {organizerNav && (
                  <span className="truncate text-xl font-bold tracking-[-0.03em] text-grey10 dark:text-white">
                    {organizerNav.items.find((item) => item.active)?.label}
                  </span>
                )}
              </div>

              {/* Mobile Explore (city) dropdown */}
              {searchAndLocationCondition() && (
                <div className="explore-city-menu relative mx-2">
                  <button
                    type="button"
                    onClick={() => setCityMenuOpen((v) => !v)}
                    className="flex items-center gap-1 h-[48px] px-3 rounded bg-grey99 dark:bg-nightElevated text-grey20 dark:text-nightTextSecondary font-semibold text-sm whitespace-nowrap"
                  >
                    Explore
                    <ChevronDown
                      className={`w-4 h-4 transition-transform ${cityMenuOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  {cityMenuOpen && renderExploreMenu()}
                </div>
              )}
              {/* Icons */}
              <div className="flex items-center gap-1">
                {isAuthenticated && routeCondition() && !organizerNav && (
                  <a
                    href="/organizations/events/create"
                    className="text-primary30 font-bold text-base hover:underline"
                    style={{ lineHeight: "24px" }}
                  >
                    <PlusIcon color="#009CA6" />
                  </a>
                )}
                {/* Hamburger menu */}
                {onMenuClick && !organizerNav && (
                  <button
                    className=" p-2 rounded hover:bg-gray-100 dark:hover:bg-white/10"
                    onClick={onMenuClick}
                    aria-label="Open menu"
                  >
                    <ProfileMenuIcon />
                  </button>
                )}

                {mounted && isAuthenticated && organizerNav && (
                  <>
                    <button
                      type="button"
                      onClick={() => navigate("/help")}
                      className="flex h-10 w-10 items-center justify-center rounded-full text-grey20 transition-colors hover:bg-grey99 dark:text-nightTextSecondary dark:hover:bg-nightSurface [&_path]:stroke-current [&_svg]:h-[22px] [&_svg]:w-[22px]"
                      aria-label="Help"
                    >
                      <IconHelpSquare size={24} stroke={1.5} color="#354052" />
                    </button>
                    <OrganizationSelector
                      variant="topbar"
                      email={organizerNav.email}
                      menuItems={profileMenuItems}
                      topMenuItems={[switchToAttendingMenuItem]}
                      logoOnly
                    />
                  </>
                )}

                {mounted &&
                  !organizerNav &&
                  (isAuthenticated ? (
                    <button
                      data-testid="profile-mobile"
                      className=" p-2 rounded"
                      onClick={() => setUserOpen((v) => !v)}
                    >
                      <Avatar
                        src={user?.profileImage}
                        name={`${user?.firstName || ""} ${user?.lastName || ""}`.trim()}
                        seed={user?.userId}
                        size={32}
                      />
                    </button>
                  ) : (
                    <button
                      className={`p-2 rounded hover:bg-gray-100 dark:hover:bg-white/10 ${compactSwapTheme ? "text-white dark:text-grey20" : "text-grey20 dark:text-nightTextSecondary"}`}
                      onClick={() => setUserOpen((v) => !v)}
                      aria-label="Open menu"
                    >
                      <HamburgerIcon />
                    </button>
                  ))}
                {userOpen && !organizerNav && renderUserMenu(isAuthenticated ? attendeeMenuItems : guestMobileMenuItems, "right-4 top-[60px]")}
              </div>
            </>
          )}
        </div>
      </header>
      )}
      {/* Mobile Bottom Nav (organizer mode only) */}
      {organizerNav && (
        <nav
          className="md:hidden fixed bottom-0 left-0 right-0 z-[9999] h-[49px] bg-white dark:bg-nightBg border-t border-black/[0.06] dark:border-white/[0.06] flex items-stretch"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          {organizerNav.items.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={item.onClick}
              aria-label={item.label}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors ${item.active ? "text-white dark:text-nightBg" : "text-grey40 dark:text-nightMuted"}`}
            >
              <span className={`flex h-8 w-12 items-center justify-center rounded-full transition-colors [&_svg]:h-5 [&_svg]:w-5 ${item.active ? "bg-grey10 dark:bg-white" : ""}`}>
                {item.icon}
              </span>
            </button>
          ))}
        </nav>
      )}
      {/* Desktop Header (sticky) */}
      <header
        className={`w-full ${compactSwapTheme ? "bg-nightBg dark:bg-[#E8E8E8]" : organizerNav ? "bg-white/95 dark:bg-nightBg/95 border-b border-black/[0.06] dark:border-white/[0.06]" : "bg-white/95 dark:bg-nightBg/95 border-b border-black/[0.06] dark:border-white/[0.06]"} h-[76px] sticky top-0 z-[9999] hidden md:flex transition-colors`}
      >
        <div className={`w-full h-full flex items-center justify-between${isOrganizationPage ? " px-4" : " max-w-[1200px] mx-auto max-[1200px]:px-4"}`}>
          {/* Logo */}
          {!organizerNav && <div className="flex items-center gap-2">
            <a href="/">
              {compactSwapTheme ? (
                <>
                  <LogoBigWhite className="dark:hidden" />
                  <LogoBigBlack className="hidden dark:block" />
                </>
              ) : (
                <>
                  <LogoBigColor className="dark:hidden" />
                  <LogoBigWhite className="hidden dark:block" />
                </>
              )}
            </a>
          </div>}
          {/* Organizer Nav (left-aligned, next to logo) */}
          {organizerNav && (
            <nav className="flex items-center gap-1">
              {organizerNav.items.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={item.onClick}
                  className={`flex h-10 items-center gap-2 rounded-full px-4 text-[15px] font-medium whitespace-nowrap transition-colors ${item.active ? "bg-grey10 text-white dark:bg-white dark:text-nightBg" : "text-grey40 hover:bg-grey99 hover:text-grey10 dark:text-nightMuted dark:hover:bg-nightSurface dark:hover:text-white"}`}
                >
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center [&_svg]:h-5 [&_svg]:w-5">
                    {item.icon}
                  </span>
                  {item.label}
                </button>
              ))}
            </nav>
          )}
          {/* Search & Explore */}
          <div className="flex-1 flex items-center gap-3 ml-6">
            {/* Search Bar */}
            {searchAndLocationCondition() && (
              <form
                className="flex-1 max-w-[360px] flex"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (search.trim()) {
                    const searchParams = new URLSearchParams();
                    searchParams.set("q", search.trim());
                    if (
                      selectedLocation &&
                      selectedLocation.city &&
                      selectedLocation.city !== "my-location"
                    ) {
                      searchParams.set("location", selectedLocation.city);
                    }
                    navigate(`/search?${searchParams.toString()}`);
                  }
                }}
              >
                <label className={`group flex h-11 w-full items-center gap-2.5 rounded-full px-4 ring-1 transition-all focus-within:ring-2 ${compactSwapTheme
                  ? "bg-nightSecondary ring-white/10 focus-within:ring-nightAccent dark:bg-grey99 dark:ring-black/5"
                  : "bg-grey99 ring-transparent hover:ring-grey90 focus-within:bg-white focus-within:ring-primary/60 dark:bg-nightSurface dark:hover:ring-nightBorder dark:focus-within:bg-nightSurface dark:focus-within:ring-nightAccent/60"}`}>
                  <SearchIcon className={`h-[18px] w-[18px] shrink-0 ${compactSwapTheme ? "text-white/60 dark:text-grey50" : "text-grey50 group-focus-within:text-primary dark:text-nightMuted dark:group-focus-within:text-nightAccent"}`} />
                  <input
                    type="text"
                    aria-label="Search"
                    placeholder="Search events, organizers, cities"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className={`min-w-0 flex-1 bg-transparent text-sm ${compactSwapTheme ? "text-white placeholder:text-white/50 dark:text-[#080808] dark:placeholder:text-grey50" : "text-grey10 placeholder:text-grey50 dark:text-white dark:placeholder:text-nightMuted"}`}
                  />
                </label>
              </form>
            )}

            {/* Explore (city) dropdown */}
            {searchAndLocationCondition() && (
              <div className="explore-city-menu relative flex-shrink-0 ml-2">
                <button
                  type="button"
                  onClick={() => setCityMenuOpen((v) => !v)}
                  className={`flex h-10 items-center gap-1 rounded-full px-4 text-[15px] font-medium whitespace-nowrap transition-colors ${compactSwapTheme ? "text-white dark:text-[#4B5563] hover:bg-white/10 dark:hover:bg-black/5" : `text-grey20 hover:bg-grey99 hover:text-grey10 dark:text-nightTextSecondary dark:hover:bg-nightSurface dark:hover:text-white ${cityMenuOpen ? "bg-grey99 text-grey10 dark:bg-nightSurface dark:text-white" : ""}`}`}
                >
                  Explore
                  <ChevronDown
                    className={`w-4 h-4 transition-transform ${cityMenuOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {cityMenuOpen && renderExploreMenu()}
              </div>
            )}
          </div>

          {/* Nav Links */}
          {!organizerNav && (
            <nav className="ml-4 flex items-center gap-1">
              {routeCondition() && (
                <a
                  href="/help"
                  className={`flex h-10 items-center rounded-full px-4 text-[15px] font-medium whitespace-nowrap transition-colors ${compactSwapTheme ? "text-white dark:text-[#4B5563] hover:bg-white/10 dark:hover:bg-black/5" : "text-grey20 hover:bg-grey99 hover:text-grey10 dark:text-nightTextSecondary dark:hover:bg-nightSurface dark:hover:text-white"}`}
                >
                  Help
                </a>
              )}
              <a
                href="/organizations"
                className={`ml-1 flex h-10 items-center gap-1.5 rounded-full px-4 text-[15px] font-medium whitespace-nowrap transition-colors ring-1 ${compactSwapTheme ? "text-white ring-white/20 hover:bg-white/10 dark:text-[#007D85] dark:ring-black/10 dark:hover:bg-black/5" : "text-grey10 ring-grey90 hover:ring-grey70 hover:bg-grey99 dark:text-white dark:ring-nightBorder dark:hover:bg-nightSurface dark:hover:ring-nightMuted/50"}`}
              >
                {isAuthenticated && isOrganizer ? (
                  <>
                    <ArrowLeftRight className="w-4 h-4" /> Switch to Organizing
                  </>
                ) : (
                  <>
                    I'm an Organizer <ArrowUpRight className="w-4 h-4" />
                  </>
                )}
              </a>
            </nav>
          )}
          {/* User Menu */}
          <div className="relative ml-3 flex items-center gap-2">
            {/* {mounted && (
                        <div className="relative">
                            <button data-cart-button className="relative" onClick={() => setCartOpen((v) => !v)}>
                                <Cart />
                                <span className="absolute -top-1 -right-1 bg-primary40 text-white text-xs rounded-full px-1">{cart.length}</span>
                            </button>
                            <CartPopup open={cartOpen} onClose={() => setCartOpen(false)} cart={cart} />
                        </div>
                    )} */}
            {mounted && isAuthenticated && organizerNav && (
              <OrganizationSelector
                variant="topbar"
                email={organizerNav.email}
                menuItems={profileMenuItems}
                topMenuItems={[switchToAttendingMenuItem]}
              />
            )}
            {mounted &&
              !organizerNav &&
              (isAuthenticated ? (
                <button
                  data-testid="profile"
                  className={`flex items-center gap-1.5 rounded-full p-1 pr-2.5 ring-1 transition-all ${userOpen ? "ring-primary/60 dark:ring-nightAccent/60" : "ring-grey90 hover:ring-grey70 dark:ring-nightBorder dark:hover:ring-nightMuted/50"}`}
                  onClick={() => setUserOpen((v) => !v)}
                >
                  <Avatar
                    src={user?.profileImage}
                    name={`${user?.firstName || ""} ${user?.lastName || ""}`.trim()}
                    seed={user?.userId}
                    size={34}
                  />
                  <ChevronDown className={`h-4 w-4 transition-transform ${compactSwapTheme ? "text-white dark:text-grey40" : "text-grey40 dark:text-nightMuted"} ${userOpen ? "rotate-180" : ""}`} />
                </button>
              ) : (
                <>
                  <a
                    href="/login"
                    className={`flex h-10 items-center rounded-full px-4 text-[15px] font-medium whitespace-nowrap transition-colors ${compactSwapTheme ? "text-white dark:text-[#4B5563] hover:bg-white/10 dark:hover:bg-black/5" : "text-grey20 hover:bg-grey99 hover:text-grey10 dark:text-nightTextSecondary dark:hover:bg-nightSurface dark:hover:text-white"}`}
                  >
                    Login
                  </a>
                  <a
                    href="/signup"
                    className="flex h-10 items-center rounded-full bg-grey10 px-5 text-[15px] font-semibold whitespace-nowrap text-white transition-colors hover:bg-black dark:bg-white dark:text-nightBg dark:hover:bg-grey90"
                  >
                    Sign up
                  </a>
                </>
              ))}
            {userOpen && isAuthenticated && !organizerNav && renderUserMenu(attendeeMenuItems, "right-0 top-[52px]")}
          </div>
        </div>
      </header>
      {children}
    </>
  );
};

export default Header;
